import { createSlice } from "@reduxjs/toolkit";

import { CarPark } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, CarPark.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateCarParkData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.CAR_PARK_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateCarParkDataAction = globalStateCarParkData.actions;
export const globalStateCarParkDataReducer = globalStateCarParkData.reducer;
export type globalStateCarParkDataState = State;

export default globalStateCarParkData;
